
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PanelSection',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
